import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    SUBMIT_PAYMENT,
    paymentReceived,
    startLoading,
    stopLoading,
    CHECK_PAYMENT_STATUS,
    paymentStatusReceived,
    individualApplicantUpdated,
    GENERATE_BILL_ID,
    generateBillIdReceived
} from '../actions'

import {
    MAKING_PAYMENT_LOADING_ID,
    GENERATE_BILL_LOADING_ID
} from '../store/loaders'


function * submitPayment (paylaod){
    const {
        amount,
        phoneNumber,
        referenceId,
        userId,
        paymentMethod,
        account,
        paymentProof,
        billId,
        requestId,
        payerName
    } = paylaod.data.data
    yield put(startLoading({id:MAKING_PAYMENT_LOADING_ID}))
    try{
       const response =  yield call(DCore.post, '/payments/',{
            account,
            amount,
            userId,
            referenceId,
            paymentMethod,
            phoneNumber,
            paymentProof,
            billId,
            requestId,
            payerName
        })
        yield put(stopLoading({id:MAKING_PAYMENT_LOADING_ID}))
       yield put(paymentReceived(response.data))
       yield put(individualApplicantUpdated(paylaod.data.reqId))
    }
    catch(e){
        yield put(stopLoading({id:MAKING_PAYMENT_LOADING_ID}))
        console.log("some thing went wrong", e)
    }
}

function * checkPaymentStatus (paylaod){
    yield put(startLoading({id:MAKING_PAYMENT_LOADING_ID}))
    try{
       const response =  yield call(DCore.get, `/payments/bill/${paylaod.data}`)
        yield put(stopLoading({id:MAKING_PAYMENT_LOADING_ID}))
       yield put(paymentStatusReceived(response.data))
    }
    catch(e){
        yield put(stopLoading({id:MAKING_PAYMENT_LOADING_ID}))
        console.log("some thing went wrong", e)
    }
}


function * generateBillId (payload){
    yield put(startLoading({id:GENERATE_BILL_LOADING_ID}))
    try{
       const response =  yield call(DCore.get, `/payments/bill/${payload.data.id}/${payload.data.type}`)
        yield put(stopLoading({id:GENERATE_BILL_LOADING_ID}))
       yield put(generateBillIdReceived(response.data))
    }
    catch(e){
        yield put(stopLoading({id:GENERATE_BILL_LOADING_ID}))
        console.log("some thing went wrong", e)
    }
}



export function * paySaga(){
    yield takeLatest(SUBMIT_PAYMENT, submitPayment)
    yield takeLatest(CHECK_PAYMENT_STATUS, checkPaymentStatus)
    yield takeLatest(GENERATE_BILL_ID, generateBillId)


}